import Moment from "moment";

const ValidationHelper = {
    isEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    },
    isNumber(value) {
        var re = /[0-9]$/;
        return re.test(value);
    },
    isIntNumber(value) {
        var re = /^\d*$/;
        return re.test(value);
    },
    validateLatLon(data) {
        var re = /^-?([0-8]?[0-9]|[0-9]0)\.{1}\d{1,6}/;
        var isValid = String(data).match(re) !== null;
        return data ? isValid && this.isNumber(data) : false;
    },
    checkObjectIsNull(target) {
        for (var k in target) {
            if (typeof target[k] !== "function") {
                target[k] = target[k] === null ? "" : target[k];
            }
        }

        return target;
    },
    diffDays(start, end) {
        return new Moment(end).diff(new Moment(start), "days");
    },

    validCPF(cpf) {
        var sum;
        var remainder;
        sum = 0;

        if (cpf === "00000000000") {
            return false;
        }

        for (let i=1; i<=9; i++) {
            sum = sum + parseInt(cpf.substring(i-1, i)) * (11 - i);
        }

        remainder = (sum * 10) % 11;

        if ((remainder === 10) || (remainder === 11)) {
            remainder = 0;
        }

        if (remainder !== parseInt(cpf.substring(9, 10))) {
            return false;
        }

        sum = 0;
        for (let i = 1; i <= 10; i++) {
            sum = sum + parseInt(cpf.substring(i-1, i)) * (12 - i);
        }

        remainder = (sum * 10) % 11;

        if ((remainder === 10) || (remainder === 11)) {
            remainder = 0;
        }

        if (remainder !== parseInt(cpf.substring(10, 11))) {
            return false;
        }
        return true;
    }
};

export default ValidationHelper;
